// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.menu {
  display: flex;
  gap: 1.25rem;
  align-items: center;
}
@media (max-width: 74.0625em) {
  .menu__body {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: -100%;
    background-color: rgba(0, 117, 135, 0.937254902);
    overflow: auto;
    transition: left 0.3s ease 0s;
  }
  .menu-open .menu__body {
    left: 0;
  }
}
.menu__list {
  display: flex;
  row-gap: 0.5rem;
  column-gap: 1.25rem;
  flex-wrap: wrap;
  justify-content: center;
}
@media (max-width: 74.0625em) {
  .menu__list {
    padding-top: 6.875rem;
    padding-bottom: 1.875rem;
    flex-direction: column;
    align-items: center;
    row-gap: 1.25rem;
  }
}
.menu__link {
  font-size: 1rem;
  line-height: 1.1428571429;
  position: relative;
  z-index: 5;
  outline: none;
  transition: all 0.5s ease 0s;
}
._header-scroll .menu__link {
  font-size: 0.875rem;
}
@media (max-width: 74.0625em) {
  .menu__link:not(.menu__link_registration) {
    font-size: 1.25rem;
  }
}
.menu__link::before {
  content: "";
  position: absolute;
  width: 100%;
  height: 0.0625rem;
  bottom: -2px;
  left: 0;
  background-color: #007587;
  transform: scale(0);
  transition: transform 0.3s ease 0s;
}
@media (any-hover: hover) {
  .menu__link:hover::before {
    transform: scale(1);
  }
}
@media (any-hover: hover) {
  .menu__link_registration.link-action:hover {
    color: #fff;
    background-color: #007587 !important;
  }
  .menu__link_registration.link-action:hover::before {
    transform: scale(0);
  }
}

.link-action {
  font-size: 0.875rem;
  line-height: 1.2142857143;
  display: inline-block;
  color: #007587;
  background-color: transparent;
  padding: 0.4375rem 0.9375rem;
  transition: all 0.3s ease 0s;
  position: relative;
  z-index: 5;
  outline: none;
  border: 1px solid #007587;
}
.link-action_bgcolor {
  background-color: #92DCE5;
}
.link-action_bottom {
  color: #fff;
  border: 1px solid #fff;
}
@media (any-hover: hover) {
  .link-action_bottom:hover {
    color: #fff;
  }
}

.icon-menu {
  display: none;
  outline: none;
}
@media (max-width: 74.0625em) {
  .icon-menu {
    display: block;
    position: relative;
    width: 1.875rem;
    height: 1.125rem;
    z-index: 5;
  }
}
@media (max-width: 74.0625em) and (any-hover: none) {
  .icon-menu {
    cursor: default;
  }
}
@media (max-width: 74.0625em) {
  .icon-menu span, .icon-menu::before, .icon-menu::after {
    content: "";
    transition: all 0.3s ease 0s;
    right: 0;
    position: absolute;
    width: 100%;
    height: 0.125rem;
    background-color: #fff;
  }
  .icon-menu::before {
    top: 0;
  }
  .icon-menu::after {
    bottom: 0;
  }
  .icon-menu span {
    top: calc(50% - 0.0625rem);
  }
  .menu-open .icon-menu span, .menu-open .icon-menu::before, .menu-open .icon-menu::after {
    background-color: #007587;
  }
  .menu-open .icon-menu span {
    width: 0;
  }
  .menu-open .icon-menu::before {
    top: calc(50% - 0.0625rem);
    transform: rotate(-45deg);
  }
  .menu-open .icon-menu::after {
    bottom: calc(50% - 0.0625rem);
    transform: rotate(45deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/landing/headerMenu/headerMenu.scss","webpack://./src/assets/scss/variables.scss"],"names":[],"mappings":"AAMA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;AALD;AAYE;EADD;IAEE,eAAA;IACA,WAAA;IACA,YAAA;IACA,MAAA;IACA,WAAA;IAEA,gDAAA;IACA,cAAA;IACA,6BAAA;EAVD;EAYC;IAGC,OAAA;EAZF;AACF;AAiBC;EACC,aAAA;EACA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,uBAAA;AAfF;AAkBE;EARD;IASE,qBAAA;IACA,wBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;EAfD;AACF;AAyBC;EACC,eAAA;EACA,yBAAA;EAEA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,4BAAA;AAxBF;AA0BE;EACC,mBAAA;AAxBH;AA+BE;EACC;IACC,kBAAA;EA7BF;AACF;AAgCE;EACC,WAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EACA,YAAA;EACA,OAAA;EACA,yBC1Fc;ED2Fd,mBAAA;EACA,kCAAA;AA9BH;AAiCE;EAEE;IACC,mBAAA;EAhCH;AACF;AAgDI;EACC;IACC,WAAA;IACA,oCAAA;EA9CJ;EAgDI;IACC,mBAAA;EA9CL;AACF;;AAmEA;EACC,mBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cCnJgB;EDoJhB,6BAAA;EACA,4BAAA;EACA,4BAAA;EAEA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,yBAAA;AAjED;AAsEC;EACC,yBAAA;AApEF;AAwGC;EACC,WAAA;EACA,sBAAA;AAtGF;AAwGE;EACC;IAGC,WAAA;EAxGF;AACF;;AAqHA;EACC,aAAA;EACA,aAAA;AAlHD;AAoHC;EAJD;IAKE,cAAA;IACA,kBAAA;IACA,eAAA;IACA,gBAAA;IACA,UAAA;EAjHA;AACF;AAkHE;EAXF;IAYG,eAAA;EA/GD;AACF;AAsGC;EAWC;IAGC,WAAA;IACA,4BAAA;IACA,QAAA;IACA,kBAAA;IACA,WAAA;IACA,gBAAA;IACA,sBAAA;EAhHD;EAmHA;IACC,MAAA;EAjHD;EAoHA;IACC,SAAA;EAlHD;EAqHA;IACC,0BAAA;EAnHD;EAwHC;IAGC,yBCvQa;ED+If;EA2HC;IACC,QAAA;EAzHF;EA+HC;IACC,0BAAA;IACA,yBAAA;EA7HF;EAgIC;IACC,6BAAA;IACA,wBAAA;EA9HF;AACF","sourcesContent":["@use 'sass:math';\r\n@import '../../../assets/scss/variable-settings.scss';\r\n@import '../../../assets/scss/mixins.scss';\r\n@import '../../../assets/scss/variables.scss';\r\n\r\n\r\n.menu {\r\n\tdisplay: flex;\r\n\tgap: rem(20);\r\n\talign-items: center;\r\n\r\n\t// .menu__icon\r\n\t&__icon {}\r\n\r\n\t// .menu__body\r\n\t&__body {\r\n\t\t@media (max-width:em(1185)) {\r\n\t\t\tposition: fixed;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\ttop: 0;\r\n\t\t\tleft: -100%;\r\n\t\t\t// background-color: #fff;\r\n\t\t\tbackground-color: #007587ef;\r\n\t\t\toverflow: auto;\r\n\t\t\ttransition: left 0.3s ease 0s;\r\n\r\n\t\t\t.menu-open & {\r\n\t\t\t\t// filter: opacity(0.8);\r\n\t\t\t\t// opacity: 0.8;\r\n\t\t\t\tleft: 0;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t// .menu__list\r\n\t&__list {\r\n\t\tdisplay: flex;\r\n\t\trow-gap: rem(8);\r\n\t\tcolumn-gap: rem(20);\r\n\t\tflex-wrap: wrap;\r\n\t\tjustify-content: center;\r\n\t\t// align-items: center;\r\n\r\n\t\t@media (max-width:em(1185)) {\r\n\t\t\tpadding-top: rem(110);\r\n\t\t\tpadding-bottom: rem(30);\r\n\t\t\tflex-direction: column;\r\n\t\t\talign-items: center;\r\n\t\t\trow-gap: rem(20);\r\n\t\t\t// filter: opacity(1);\r\n\t\t\t// filter: opacity(20%);\r\n\t\t\t// opacity: 0.5;\r\n\t\t}\r\n\t}\r\n\r\n\t// .menu__item\r\n\t&__item {}\r\n\r\n\t// .menu__link\r\n\t&__link {\r\n\t\tfont-size: rem(16);\r\n\t\tline-height: math.div(16, 14);\r\n\t\t// transition: color 0.3s ease 0s;\r\n\t\tposition: relative;\r\n\t\tz-index: 5;\r\n\t\toutline: none;\r\n\t\ttransition: all 0.5s ease 0s;\r\n\r\n\t\t._header-scroll & {\r\n\t\t\tfont-size: rem(14);\r\n\t\t}\r\n\r\n\t\t// &:focus {\r\n\t\t// \tbox-shadow: 0px 0px 0px 3px rgba(17, 157, 164, 0.25);\r\n\t\t// }\r\n\r\n\t\t@media (max-width:em(1185)) {\r\n\t\t\t&:not(.menu__link_registration) {\r\n\t\t\t\tfont-size: rem(20)\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t&::before {\r\n\t\t\tcontent: '';\r\n\t\t\tposition: absolute;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: rem(1);\r\n\t\t\tbottom: -2px;\r\n\t\t\tleft: 0;\r\n\t\t\tbackground-color: $mainBrandColor;\r\n\t\t\ttransform: scale(0);\r\n\t\t\ttransition: transform 0.3s ease 0s;\r\n\t\t}\r\n\r\n\t\t@media (any-hover: hover) {\r\n\t\t\t&:hover {\r\n\t\t\t\t&::before {\r\n\t\t\t\t\ttransform: scale(1);\r\n\t\t\t\t}\r\n\t\t\t}\r\n\t\t}\r\n\r\n\t\t// // .menu__link_active\r\n\t\t// &.active {\r\n\t\t// \ttext-shadow: none;\r\n\r\n\t\t// \t&::before {\r\n\t\t// \t\ttransform: scale(1);\r\n\t\t// \t}\r\n\t\t// }\r\n\r\n\t\t// .menu__link_registration\r\n\t\t&_registration {\r\n\t\t\t&.link-action {\r\n\t\t\t\t@media (any-hover: hover) {\r\n\t\t\t\t\t&:hover {\r\n\t\t\t\t\t\tcolor: #fff;\r\n\t\t\t\t\t\tbackground-color: $mainBrandColor !important;\r\n\r\n\t\t\t\t\t\t&::before {\r\n\t\t\t\t\t\t\ttransform: scale(0);\r\n\t\t\t\t\t\t}\r\n\t\t\t\t\t}\r\n\t\t\t\t}\r\n\t\t\t}\r\n\r\n\t\t\t// text-shadow: none;\r\n\t\t\t// transition: all 0.3s ease 0s;\r\n\r\n\t\t\t// @media (any-hover: hover) {\r\n\t\t\t// \t&:hover {\r\n\t\t\t// \t\tcolor: #fff;\r\n\r\n\t\t\t// \t\t&::before {\r\n\t\t\t// \t\t\ttransform: scale(0);\r\n\t\t\t// \t\t}\r\n\t\t\t// \t}\r\n\t\t\t// }\r\n\t\t}\r\n\t}\r\n}\r\n\r\n.link-action {\r\n\tfont-size: rem(14);\r\n\tline-height: math.div(17, 14);\r\n\tdisplay: inline-block;\r\n\tcolor: $mainBrandColor;\r\n\tbackground-color: transparent;\r\n\tpadding: rem(7) rem(15);\r\n\ttransition: all 0.3s ease 0s;\r\n\t// font-weight: 600;\r\n\tposition: relative;\r\n\tz-index: 5;\r\n\toutline: none;\r\n\tborder: 1px solid $mainBrandColor;\r\n\r\n\t// &:focus {\r\n\t// \tbox-shadow: 0px 0px 0px 3px rgba(17, 157, 164, 0.25);\r\n\t// }\r\n\t&_bgcolor {\r\n\t\tbackground-color: #92DCE5;\r\n\t}\r\n\r\n\r\n\r\n\t// @media (any-hover: hover) {\r\n\t// \t&:hover {\r\n\t// \t\tbackground-color: $mainBrandColor;\r\n\t// \t}\r\n\r\n\t// \t// &:active {\r\n\t// \t// \tbackground-color: #00767C;\r\n\t// \t// }\r\n\t// }\r\n\r\n\r\n\r\n\t// &_top {\r\n\t// \t// font-weight: 400;\r\n\t// \tcolor: $mainBrandColor;\r\n\t// \tbackground-color: #92DCE5;\r\n\r\n\t// \t@media (any-hover: hover) {\r\n\t// \t\t&:hover {\r\n\t// \t\t\tcolor: #fff;\r\n\t// \t\t\t// color: #12BDC6;\r\n\t// \t\t\t// background-color: #F1F1F9;\r\n\t// \t\t}\r\n\r\n\t// \t\t// &:active {\r\n\t// \t\t// \t// color: #00767C;\r\n\t// \t\t// \t// background-color: #EFEFEF;\r\n\t// \t\t// }\r\n\t// \t}\r\n\t// }\r\n\r\n\t&_bottom {\r\n\t\tcolor: #fff;\r\n\t\tborder: 1px solid #fff;\r\n\r\n\t\t@media (any-hover: hover) {\r\n\t\t\t&:hover {\r\n\t\t\t\t// border: 1px solid $mainBrandColor;\r\n\t\t\t\t// color: #12BDC6;\r\n\t\t\t\tcolor: #fff;\r\n\t\t\t}\r\n\r\n\t\t\t// &:active {\r\n\t\t\t// \t// color: #00767C;\r\n\t\t\t// }\r\n\t\t}\r\n\t}\r\n}\r\n\r\n//====================================================================================================\r\n\r\n//Burger\r\n\r\n.icon-menu {\r\n\tdisplay: none;\r\n\toutline: none;\r\n\r\n\t@media (max-width: em(1185)) {\r\n\t\tdisplay: block;\r\n\t\tposition: relative;\r\n\t\twidth: rem(30);\r\n\t\theight: rem(18);\r\n\t\tz-index: 5;\r\n\r\n\t\t@media (any-hover: none) {\r\n\t\t\tcursor: default;\r\n\t\t}\r\n\r\n\t\tspan,\r\n\t\t&::before,\r\n\t\t&::after {\r\n\t\t\tcontent: \"\";\r\n\t\t\ttransition: all 0.3s ease 0s;\r\n\t\t\tright: 0;\r\n\t\t\tposition: absolute;\r\n\t\t\twidth: 100%;\r\n\t\t\theight: rem(2);\r\n\t\t\tbackground-color: #fff;\r\n\t\t}\r\n\r\n\t\t&::before {\r\n\t\t\ttop: 0;\r\n\t\t}\r\n\r\n\t\t&::after {\r\n\t\t\tbottom: 0;\r\n\t\t}\r\n\r\n\t\tspan {\r\n\t\t\ttop: calc(50% - rem(1));\r\n\t\t}\r\n\r\n\t\t.menu-open & {\r\n\r\n\t\t\tspan,\r\n\t\t\t&::before,\r\n\t\t\t&::after {\r\n\t\t\t\tbackground-color: $mainBrandColor;\r\n\t\t\t}\r\n\r\n\t\t\tspan {\r\n\t\t\t\twidth: 0;\r\n\t\t\t}\r\n\r\n\t\t\t&::before,\r\n\t\t\t&::after {}\r\n\r\n\t\t\t&::before {\r\n\t\t\t\ttop: calc(50% - rem(1));\r\n\t\t\t\ttransform: rotate(-45deg);\r\n\t\t\t}\r\n\r\n\t\t\t&::after {\r\n\t\t\t\tbottom: calc(50% - rem(1));\r\n\t\t\t\ttransform: rotate(45deg);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}","$mainBrandColor: #007587;\r\n$mainBgGrey: #F0F8F2;\r\n$mainHoverButtonColor: #EDF5F6;\r\n$mainDarkGreen: #003300;\r\n$mainLightBlue: #92DCE5;\r\n\r\n$mainCardTextDarkGrey: #787878;\r\n$mainCardDateGrey: #A8A8A8;\r\n$mainCardTagDarkGrey: #6A6A6A;\r\n$mainLightGrey: #f6f6f6;\r\n$mainCardButtonDark: #383D3B;\r\n$mainSubtitleDarkGrey: #A9A9A9;\r\n$mainDarkCyan: #119DA4;\r\n$mainDarkenDarkCyan: #0082ca;"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
